import routes, { tRouteNames } from './routeConfig'
import { canSeeRoutePath } from './routeVisibility'
import { isFeatureEnabled } from 'src/features'

export const preloadRoute = (name: tRouteNames): void => {
  const route = routes[name]
  if (!route || !isFeatureEnabled(route.feature)) return
  // A speculative download must not create an unhandled rejection offline.
  void route.Component.preload().catch(() => undefined)
}

export const preloadRoutePath = (path: string, haveRight: (right: string) => boolean): void => {
  if (!canSeeRoutePath(path, haveRight)) return
  const normalized = `/${path.split('?')[0].replace(/^\/+/, '')}`
  const route = Object.entries(routes).find(([, value]) => value.paths.includes(normalized))
  if (route) preloadRoute(route[0] as tRouteNames)
}
